module.exports = __webpack_public_path__ + "img/chevron-bar-right.94fe0439.svg";